import { useState } from "react"
import ActivitiesPdf from "../components/ActivitiesPdf"
import { pdf } from "@react-pdf/renderer"

export const useDownloadPdf = () => {
  const [isLoading, setIsLoading] = useState(false)

  const download = async (selected) => {
    setIsLoading(true)
    try {
      const activitiesPdf = <ActivitiesPdf activities={selected} />

      const blob = await pdf(activitiesPdf).toBlob()

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "atividades-estimule.pdf")

      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)

      setTimeout(() => {
        URL.revokeObjectURL(url)
      }, 1000);
    } catch (error) {
      console.error("Error ao gerar PDF: ", error)
      alert("Não foi possível gerar o PDF. Tente novamente.")
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, download }
}
